import { render, staticRenderFns } from "./MusicManagement.vue?vue&type=template&id=69627a98&scoped=true"
import script from "./MusicManagement.vue?vue&type=script&lang=js"
export * from "./MusicManagement.vue?vue&type=script&lang=js"
import style0 from "./MusicManagement.vue?vue&type=style&index=0&id=69627a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69627a98",
  null
  
)

export default component.exports